// extracted by mini-css-extract-plugin
export default {"meal":"Meal_meal__O339e","price":"Meal_price__A9oea","description":"Meal_description__SpwhB"};